import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import CircularProgress from '@material-ui/core/CircularProgress';

class TableComponent extends Component {
  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    // If we have a paginator object, make sure we properly initialize Redux.
    if (typeof this.props.paginator !== "undefined") {
      if (typeof this.props.paginator.path[this.props.paginator.name] === "undefined") {
        this.increaseReduxPaginator(this.props.paginator.name);
      }
    }

    this.setState({
      rowsLength: this.props.rowsLength || (!!this.props.rows && this.props.rows.length),
      defaultPaginationAmount: this.props.app.defaultPaginationAmount
    })
  }

  public componentWillReceiveProps(nextProps) {
    // If we have a paginator object, make sure we properly initialize Redux.
    if (typeof nextProps.paginator !== "undefined") {
      if (typeof nextProps.paginator.path[nextProps.paginator.name] === "undefined") {
        this.increaseReduxPaginator(nextProps.paginator.name);
      }
    }

    this.setState({
      rowsLength: nextProps.rowsLength || (!!nextProps.rows && nextProps.rows.length),
      defaultPaginationAmount: nextProps.app.defaultPaginationAmount
    })
  }

  public getRowsLength = () => {
    const rowsLength = Number(this.state.rowsLength) || Number((!!this.props.rows && this.props.rows.length));

    return rowsLength;
  }

  public getPaginationAmount = (): number => {
    // if table have paginator in redux take amount from there if now take from state
    let paginationAmount: number = 
      !!this.props.paginator && !!this.props.paginator.path[this.props.paginator.name] ? 
        this.props.paginator.path[this.props.paginator.name] : this.state.defaultPaginationAmount;

    if (this.props.noPagination) {
      paginationAmount = this.getRowsLength();
    }

    return paginationAmount;
  }

  public fetch = () => {
    if (typeof this.props.fetch !== "undefined") {
      this.props.fetch.call(this);
    }
  }

  public increase = (): void => {
    if (!!this.props.paginator) {
      return this.increaseReduxPaginator(this.props.paginator.name, this.fetch);
    } else {
      return this.setState({
        defaultPaginationAmount: this.state.defaultPaginationAmount + this.props.app.defaultPaginationAmount
      }, this.fetch)
    }
  }

  public increaseReduxPaginator = (paginatorName, callback?): void => {
    this.props.dispatch({
      type: Constants.TABLE_COMPONENT_PAGINATOR_INCREASE,
      payload: {
        name: paginatorName,
        amount: this.props.app.defaultPaginationAmount
      }
    });

    if (typeof callback === "function") {
      callback();
    }
  }

  public isFiltering = (): boolean => {
    return this.props.filtering === true;
  }

  public renderIncreaseButton = (): any => {
    // If we already show everything, return null.
    if (this.getPaginationAmount() >= this.getRowsLength()) {
      return null;
    }

    if (this.props.noPagination) {
      return null;
    }

    return (
      <div className="load-more-button">
      { 
        <Button
          color="primary"
          style={{ width: "100%" }}
          onClick={this.increase}
        >
          {this.trans("button-load-more")}<div className="icon table-loadmore-icon icon-ic-keyboard-arrow-down icon-color"></div>
        </Button>
      }

      </div>
    );
  }

  public getTableHeader = (): any => {
    if (typeof this.props.headers === "undefined") {
      return null;
    }

    return (
      <TableHead>
        <TableRow hover>
          {this.props.headers.map((header: string, index: any) => {
            return (
              <TableCell
                style={{ textAlign: "right" }}
                key={index}
              >
                {header}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }

  public getRows = (): any => {
    return Array.isArray(this.props.rows) && this.props.rows?.slice(0, this.getPaginationAmount());
  }

  public render() {
    // If we are still fetching the data, we should not show anything.
    if (this.props.isFetched === false) {
      return null;
    }

    // If we fetched the data and made sure there are no rows, we should show the subtitle text.
    if (this.getRowsLength() === 0 && typeof this.props.subtitle !== "undefined" && this.isFiltering() === false) {
      return (
        <Card className="card empty-table-notice" style={this.props.subtitleStyle}>
          <CardHeader
            title={this.props.title || ""}
            subheader={this.props.isFetching ? (
              <div style={{display: "flex", justifyContent: "center"}}>
                <CircularProgress />
              </div>
            ) : this.props.subtitle}
          />
        </Card>
      );
    }

    // If we have a second subtitle, always show it.
    if (typeof this.props.stickySubtitle === "string") {
      return (
        <div>
          <Card className="card empty-table-notice">
            <CardHeader
              title={this.props.title}
              subheader={this.props.isFetching ? (
                <div style={{display: "flex", justifyContent: "center"}}>
                  <CircularProgress />
                </div>
              ) : this.props.stickySubtitle}
            />
          </Card>

          <Table
            style={{ marginTop: "1px" }}
            className={typeof this.props.className === "undefined" ? "listing-table" : this.props.className}
          >
            {this.getTableHeader()}
            <TableBody>
              {this.getRows()}
            </TableBody>
          </Table>
          {this.renderIncreaseButton()}
        </div>
      );
    }

    // Otherwise, render the table.
    return (
      <div>
        <Table
          className={typeof this.props.className === "undefined" ? "listing-table" : this.props.className}
          style={{display: this.state.tableDisplayStyle}}
        >
          {this.getTableHeader()}
          <TableBody>
            {this.getRows()}
          </TableBody>
        </Table>
        {this.renderIncreaseButton()}
      </div>
    );
  }
}

export { TableComponent };